import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import { AmplifyAuthenticator } from '@aws-amplify/ui-react';
import AmplifySignCom from './AmplifySignCom';

import App from './App';
import Download from './Download';
import Admin from './Admin';
import Login from './Login';
import Sign from './Sign';
import ForgotPassword from './ForgotPassword';
export default function Rout() {
  return (
    <Router>
      
      <div>
        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
        <Switch>
          
            <Route path="/save">
              <AmplifyAuthenticator>
                <AmplifySignCom />
                <App />
              </AmplifyAuthenticator>
            </Route>
            <Route path="/download">
                <Download />
            </Route>
            <Route path="/admin">
              <AmplifyAuthenticator>
                <AmplifySignCom />
                <Admin />
              </AmplifyAuthenticator>
            </Route>
            <Route path="/login">
              <Login />
            </Route>
            <Route path="/sign">
              <Sign />
            </Route>
            <Route path="/forgot_password">
              <ForgotPassword />
            </Route>
        
        </Switch>
      </div>
    </Router>
  );
}